import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import DropDown from "./DropDown";
import LanguageFilters from "./LanguageFilters";

// style rules
import { Colors, Sizes, Typography } from "../../styles";

const TicketForm = ({
	filters,
	// languages,
	selectedSchool,
	setSelectedSchool,
	// setSelectedLanguage,
	// selectedLanguage,
	ticket,
}) => {
	return (
		<Wrapper>
			<Title>1. Enter your information</Title>
			<FormContainer
			// ?
				// paddingBottom={selectedSchool && selectedLanguage && !ticket}
			>
				<DropDown
					filters={filters}
					selectedSchool={selectedSchool}
					setSelectedSchool={setSelectedSchool}
				/>
				{/* <div>
					<LanguageFilters
						languages={languages}
						selectedLanguage={selectedLanguage}
						setSelectedLanguage={setSelectedLanguage}
					/>
					{!ticket && selectedSchool && selectedLanguage && (
						<ErrorMessage>
							*No pass is available for the selected fields
						</ErrorMessage>
					)}
				</div> */}
			</FormContainer>
		</Wrapper>
	);
};

export default TicketForm;

TicketForm.propTypes = {
	filters: PropTypes.array,
	// languages: PropTypes.array,
	// setSelectedLanguage: PropTypes.func,
	// selectedLanguage: PropTypes.string,
	selectedSchool: PropTypes.string,
	setSelectedSchool: PropTypes.func,
	ticket: PropTypes.object,
};

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.5rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		flex: 0 0 519px;
		gap: 4rem;
	}
`;
const FormContainer = styled.div`
	background-color: ${Colors.base.white};
	padding: 2.4rem 2.7rem;
	margin: 0;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4rem;
	position: relative;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		padding: 7.3rem 7.5rem
			${(props) => (props.paddingBottom ? "4.5rem" : "7.3rem")};
		justify-content: space-between;
		gap: 6rem;
		min-height: 390px;
	}
`;
const Title = styled.h3`
	font-size: 2.4rem;
	line-height: 3rem;
	letter-spacing: -0.31px;
`;

const ErrorMessage = styled.p`
	color: ${Colors.messages.error};
	font-weight: ${Typography.fontWeight.medium};
	margin-top: 5rem;
`;
